import React from 'react'

const Icon = ({
  children,
  viewBox = '1 1 23 23',
  disabled = false,
  style = {},
  stroke
}) => {
  return (
    <svg
      fill={disabled ? '#eee' : 'rgba(0,0,0,0.57)'}
      stroke={stroke || 'transparent'}
      style={{
        width: 25,
        height: 25,
        ...style
      }}
      viewBox={viewBox}
    >
      {children}
    </svg>
  )
}

export default Icon



// WEBPACK FOOTER //
// ./src/components/Icons/icon.js